<template>
  <div class="chartersWrapper">
    <div v-if="dashboardType === 'provider'" class="availabilityDashboard availabilityDashboard--charter">
      <vue-scroll :ops="ops">
        <CharterUploadsForm/>
      </vue-scroll>
    </div>
    <div v-else class="flightUploadsDashboard js-tabBox flightUploadsDashboard--charter">
      <vue-scroll :ops="ops">
        <div class="flightUploadsDashboard__header">
          <div class="flightUploadsDashboard__title">Flight upload functionality and record of all uploads</div>
          <div class="flightUploadsDashboard__nav">
            <div class="flightUploadsDashboard__nav-item js-tabNavItem" @click="tabActivate">
              <span class="text">Current</span>
            </div>
            <div class="flightUploadsDashboard__nav-item js-tabNavItem" @click="tabActivate">
              <span class="text">Historical</span>
            </div>
          </div>
        </div>
        <div class="flightUploadsDashboard__content">
          <div class="flightUploadsDashboard__content-item js-tabContentItem">
            <CharterUploadsForm/>
          </div>
          <div class="flightUploadsDashboard__content-item js-tabContentItem">
            <CharterUploadsForm/>
          </div>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
  import CharterUploadsForm from '@/components/dashboard/CharterUploadsForm/CharterUploadsForm'
  import { Tabs } from '@/js/plugins/tabs'
  import '@/views/dashboard/common/FlightUploads/FlightUploads.styl'

  export default {
    props: ['dashboardType'],
    name: 'CharterUploads',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      ops: {
        scrollPanel: {
          initialScrollX: false,
          scrollingX: false,
        },
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
    }),
    mounted () {
      this.tabs.addActiveForMouted()
    },
    methods: {
      tabActivate (event) {
        this.tabs.addActiveForClick(event.currentTarget)
      },
    },
    components: {
      CharterUploadsForm,
    },
  }
</script>
